var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContactEdit = function SvgContactEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 19.47,
    y1: 151.44,
    x2: 100.15,
    y2: 36.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 59.73,
    y1: 179.78,
    x2: 140.42,
    y2: 65.14,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 117.88,
    y1: 220.7,
    x2: 198.56,
    y2: 106.06,
    xlinkHref: "#b"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M97.26,81.83c22.57,0,40.92-18.36,40.92-40.91S119.82,0,97.26,0s-40.92,18.36-40.92,40.92,18.35,40.91,40.92,40.91ZM97.26,14.29c14.68,0,26.63,11.95,26.63,26.63s-11.95,26.63-26.63,26.63-26.63-11.95-26.63-26.63,11.95-26.63,26.63-26.63Z",
    style: {
      fill: "url(#b)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.96,181.71c-1.19-.88-2.58-1.49-4.16-1.49h-56.28c-8.18,0-14.83-6.65-14.83-14.83,0-16.14,6.3-31.33,17.73-42.77,11.43-11.43,26.65-17.73,42.85-17.73s31.41,6.3,42.84,17.73c2.48,2.47,4.72,5.15,6.68,7.97.46.66,1.06,1.15,1.68,1.61,2.4,1.76,5.7,1.97,8.27.18,3.24-2.25,4.04-6.7,1.79-9.94-2.44-3.51-5.23-6.84-8.3-9.91-14.13-14.13-32.94-21.92-52.94-21.92s-38.82,7.78-52.95,21.92c-14.13,14.14-21.92,32.91-21.92,52.87,0,16.05,13.06,29.12,29.12,29.12h56.28c3.95,0,7.14-3.2,7.14-7.14,0-2.36-1.22-4.35-2.98-5.65Z",
    style: {
      fill: "url(#c)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.47,166.35h-12.22v-12.22c0-3.94-3.19-7.14-7.14-7.14s-7.14,3.2-7.14,7.14v12.22h-12.22c-3.95,0-7.14,3.2-7.14,7.14s3.2,7.14,7.14,7.14h12.22v12.22c0,3.94,3.2,7.14,7.14,7.14s7.14-3.2,7.14-7.14v-12.22h12.22c3.95,0,7.14-3.2,7.14-7.14s-3.19-7.14-7.14-7.14Z",
    style: {
      fill: "url(#d)",
      strokeWidth: 0
    }
  }));
};
export default SvgContactEdit;